import React, { useContext } from 'react'
import LayoutAccountStatement from './LayoutAccountStatement'
import EditorAccountStatementBanner from './EditorAccountStatementBanner'
import { AccountStatementContext } from '../context/AccountStatementContext'
import { useIntl } from 'react-intl'

export default function AccountStatementPanel() {
   const { config } = useContext(AccountStatementContext)
   const intl = useIntl()

   return (
      <div>
         {config?.isEditable === false && (
            <div className='w-auto border border-yellow-500 rounded-lg m-4 bg-white shadow-sm p-4 bg-yellow-50'>
               {intl.formatMessage({ id: 'settings.layout.urlTerms' }, {
                  hours: config?.editableInHours || 24
               })}
            </div>
         )}
         <div className={`flex gap-y-4  gap-x-6 mx-4 ${config?.isEditable === false ? 'pointer-events-none opacity-50' : ''}`}>
            <LayoutAccountStatement />
            <EditorAccountStatementBanner />
         </div>
      </div>
   )
}
